<!--  -->
<mat-stepper
  [selectedIndex]="selectedStepIndex()"
  orientation="vertical"
  [linear]="isLinear"
  #business_registration_stepper
>
  <mat-step
    *ngFor="let stepper of businessFormConfig(); let i = index"
    [stepControl]="businessRegistrationForm"
  >
    <form [formGroup]="businessRegistrationForm">
      <ng-template matStepLabel>
        <div (click)="updateStepIndex(i)">
          {{ stepper?.label }}
        </div>
      </ng-template>
      @if (
        handleInfoMessages?.[0]?.[selectedBusinessIdentificationValue()] &&
        stepper?.businessInfoMessage
      ) {
        <div [innerHTML]="stepper?.businessInfoMessage | safeHtml"></div>
      }
      <div
        class="grid grid-cols-1 md:grid-cols-4 gap-x-[25px] gap-y-[15px] mt-4 mb-4"
      >
        <ng-container *ngFor="let field of stepper?.fields">
          <!-- Text Input -->
          <div
            *ngIf="field.type === inputTypeEnum.TEXT && isFieldEnabled(field)"
            class="md:col-span-2"
            [style]="field.style"
          >
            <div class="relative">
              <mat-form-field
                appearance="outline"
                class="w-full"
                [ngClass]="{ 'form-field-disabled': field?.isDisable }"
                *ngIf="!isFieldHidden(field?.name)"
              >
                <mat-label class="!text-[14px]">{{
                  placeHolder()?.[field?.name]
                }}</mat-label>
                <input
                  matInput
                  [disabled]="field?.isDisable"
                  [readonly]="field?.isDisable"
                  [id]="field?.name"
                  [formControlName]="field?.name"
                  [placeholder]="placeHolder()?.[field?.name]"
                  [attr.minlength]="field?.minlength"
                  [attr.maxlength]="field?.maxlength"
                  [type]="field?.type"
                  class="placeholder-truncate w-full rounded-sm !text-[14px] -translate-y-[7px]"
                  [ngStyle]="{ borderColor: '#494949' }"
                  (input)="checkAndTransformInput($event, field)"
                  (click)="
                    handleEvent(
                      $event,
                      field,
                      field.actions?.event?.onClick?.functionName,
                      field.actions?.event?.onClick?.params
                    )
                  "
                  (blur)="
                    handleEvent(
                      $event,
                      field,
                      field.actions?.event?.onBlur?.functionName,
                      field.actions?.event?.onBlur?.params
                    )
                  "
                  (keypress)="handleInput($event, field)"
                />
                <div
                  *ngIf="field?.isVerified"
                  class="icon absolute flex items-center justify-center -top-[11px] bottom-1 right-px px-[10px]"
                >
                  <img
                    src="../assets/assets-new/images/check-1.svg"
                    class="w-5 h-5 flex-shrink-0"
                  />
                </div>

                <mat-error
                  *ngIf="
                    businessRegistrationForm.get(field.name).touched &&
                    businessRegistrationForm.get(field.name).errors
                  "
                >
                  @if (
                    businessRegistrationForm.get(field?.name)?.errors
                      .customError &&
                    errorMessage()?.[field?.name]?.type === MessageType.ERROR
                  ) {
                    <span>{{ errorMessage()?.[field?.name]?.text }}</span>
                  } @else if (
                    businessRegistrationForm
                      .get(field.name)
                      .hasError('required')
                  ) {
                    <span>{{
                      field?.validation?.errorMessages?.required
                    }}</span>
                  } @else if (
                    businessRegistrationForm
                      .get(field.name)
                      .hasError('minlength') &&
                    field?.validation?.errorMessages?.minlength
                  ) {
                    <span>{{
                      field?.validation?.errorMessages?.minlength
                    }}</span>
                  } @else if (
                    businessRegistrationForm.get(field.name).hasError('pattern')
                  ) {
                    <span>{{ field?.validation?.errorMessages?.pattern }}</span>
                  }
                </mat-error>
              </mat-form-field>
            </div>

            <div
              *ngIf="field?.actions?.leftRightCTA"
              class="flex justify-between"
            >
              <div
                class="text-[#F94D00] font-semibold text-[12px] cursor-pointer underline mt-1"
                [style.pointer-events]="isDisable()?.leftCTA ? 'none' : 'auto'"
                [style.cursor]="
                  isDisable()?.leftCTA ? 'not-allowed' : 'pointer'
                "
                [style.color]="isDisable()?.leftCTA ? '#bbb' : 'inherit'"
                (click)="
                  isDisable()?.leftCTA
                    ? $event.preventDefault()
                    : onActionCall(
                        field?.actions?.leftRightCTA?.leftCTA?.action?.type
                      )
                "
              >
                {{ field?.actions?.leftRightCTA?.leftCTA?.title }}
              </div>
              <div
                class="underline text-[12px] text-[#F94D00] cursor-pointer font-semibold mt-1"
                [style.pointer-events]="
                  isDisable()?.[field?.name]?.rightCTA ? 'none' : 'auto'
                "
                [style.cursor]="
                  isDisable()?.[field?.name]?.rightCTA
                    ? 'not-allowed'
                    : 'pointer'
                "
                [style.color]="
                  isDisable()?.[field?.name]?.rightCTA ? '#ffa37a' : 'inherit'
                "
                (click)="
                  isDisable()?.[field?.name]?.rightCTA
                    ? $event.preventDefault()
                    : onActionCall(
                        field?.actions?.leftRightCTA?.rightCTA?.action?.type
                      )
                "
              >
                {{ field?.actions?.leftRightCTA?.rightCTA?.title }}
              </div>
            </div>

            <div id="for_action">
              <div
                *ngIf="
                  !businessRegistrationForm.get(field?.name).touched &&
                  !businessRegistrationForm.get(field?.name).errors &&
                  field?.actions?.messages?.type === MessageType.SUCCESS
                "
                class="text-[#3BB000] font-semibold text-[12px] text-left mt-1"
              >
                {{ field?.actions?.messages?.text }}
              </div>
              <div
                class="text-[#c00100] text-[13px] text-left mt-1"
                *ngIf="
                  (!businessRegistrationForm.get(field?.name).touched &&
                    !businessRegistrationForm.get(field?.name).errors &&
                    errorMessage()?.[field?.name]?.type ===
                      MessageType.ERROR) ||
                  errorMessage()?.[field?.name]?.type === MessageType.INFO
                "
              >
                {{ errorMessage()?.[field?.name]?.text }}
              </div>
            </div>
            <div
              *ngIf="field.isTimer"
              class="text-[12px] text-[red] mb-[7px] mt-[3px] text-left"
            >
              <p *ngIf="getTimerObservable(field) | async as remaining">
                {{ remaining }} {{ getTimerMessage(field.name) }}
              </p>
            </div>
          </div>
          <!-- Select Input -->
          <div
            *ngIf="field.type === inputTypeEnum.SELECT"
            class="md:col-span-2"
          >
            <mat-form-field appearance="outline" class="w-full">
              <mat-label class="!text-[14px]">{{
                field.placeholder
              }}</mat-label>
              <mat-select
                [id]="field.name"
                [formControlName]="field.name"
                class="-translate-y-[7px]"
                (selectionChange)="
                  handleEvent(
                    $event,
                    field,
                    field.actions?.event?.onChange?.functionName,
                    field.actions?.event?.onChange?.params
                  )
                "
              >
                <mat-option
                  *ngFor="let option of field.options"
                  [value]="option.value"
                  class="!text-[14px]"
                >
                  {{ option.label }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  businessRegistrationForm.get(field.name).touched &&
                  businessRegistrationForm.get(field.name).hasError('required')
                "
              >
                {{ field?.validation?.errorMessages?.required }}
              </mat-error>
            </mat-form-field>

            <!-- show messages on action -->
            <div id="for_action">
              <div
                *ngIf="
                  field?.name &&
                  !businessRegistrationForm.get(field?.name).errors &&
                  field?.actions?.messages?.type === MessageType.SUCCESS
                "
                class="text-[#3BB000] font-semibold text-[12px] text-left mt-1"
              >
                {{ field?.actions?.messages?.text }}
              </div>

              <div
                class="text-[#c00100] text-[13px] text-left mt-1"
                *ngIf="
                  !businessRegistrationForm.get(field?.name).touched &&
                  !businessRegistrationForm.get(field?.name).errors &&
                  errorMessage()?.[field?.name]?.type === MessageType.ERROR
                "
              >
                {{ errorMessage()?.[field?.name]?.text }}
              </div>
            </div>
          </div>

          <!-- file upload -->
          <div
            *ngIf="field.type === inputTypeEnum.FILE && isFieldEnabled(field)"
            class="md:col-span-2"
          >
            <media-uploader
              [data]="field?.fileUpload"
              [required]="field?.required"
              [fileId]="field?.name"
              [hideMediaUploader]="hideMediaUploader()"
              (onUpload)="onUpload($event)"
            />
            <div
              class="text-[#c00100] text-[13px] text-left mt-1"
              *ngIf="
                businessRegistrationForm.get(field?.name).touched &&
                businessRegistrationForm.get(field.name).hasError('required')
              "
            >
              {{ field?.validation?.errorMessages?.required }}
            </div>
            <div
              class="text-[#c00100] text-[13px] text-left mt-1"
              *ngIf="
                !businessRegistrationForm.get(field?.name).touched &&
                !businessRegistrationForm.get(field?.name).errors &&
                errorMessage()?.[field?.name]?.type === MessageType.ERROR
              "
            >
              {{ errorMessage()?.[field?.name]?.text }}
            </div>
          </div>

          <!-- display gst list -->
          @if (showGSTList()) {
            <div
              *ngIf="
                field.type === inputTypeEnum.RADIO &&
                field?.name === 'gstinList'
              "
              class="forme-re md:col-span-4 -mt-[15px]"
            >
              <div class="md:col-span-4 grow">
                <div class="flex justify-between w-full">
                  <div
                    class="text-[#000000] text-left font-semibold text-[14px] mb-[5px] col-span-6"
                  >
                    @if (
                      businessIdentification ===
                      VerificationTypeEnum.COMPANY_NAME
                    ) {
                      Select {{ businessIdentificationValue }}
                    } @else {
                      {{ gstListInfo.title }}
                    }
                  </div>
                  @if (gstInByPan() && showBillingAddress()) {
                    <div
                      class="text-[#3bb000] font-bold text-[13px] mb-[5px] items-center flex gap-[5px]"
                    >
                      <img
                        src="../assets/assets-new/images/check-1.svg"
                        class="w-4 flex-shrink-0"
                      /><span>{{ gstListInfo?.button?.verifiedText }}</span>
                    </div>
                  }
                </div>

                <div
                  class="text-[#c00100] text-[13px] text-left mt-1"
                  *ngIf="
                    !businessRegistrationForm.get('gstin').touched &&
                    errorMessage()?.gstin?.type === MessageType.ERROR
                  "
                >
                  {{ errorMessage()?.gstin?.text }}
                </div>
                <div
                  class="flex overflow-x-auto gap-[10px] scroll-container pb-[10px]"
                >
                  @for (gstOption of gstOptions(); track gstOption) {
                    <label>
                      <input
                        class="sr-only peer"
                        [formControlName]="inputName.GSTIN"
                        type="radio"
                        value="{{ gstOption.value }}"
                        (click)="getGstInByPanValue(gstOption.value)"
                      />
                      <div
                        class="rounded-[5px] flex items-center justify-center text-[#000000] peer-checked:bg-[#162F4D] bg-[#dbdada] peer-checked:text-[#ffffff] text-[14px] cursor-pointer"
                        style="padding: 8px 20px"
                      >
                        {{ gstOption.value }}
                      </div>
                    </label>
                  }
                </div>
              </div>
            </div>
          }

          <!-- billing address -->
          @if (showBillingAddress() && billingAddressObj()) {
            <div
              *ngIf="field?.name === inputName.BILLING_ADDRESS_LAYOUT"
              class="billing-address grow md:col-span-4"
            >
              <div class="flex justify-between items-center mb-[5px]">
                <div class="text-[#000000] font-semibold text-[14px]">
                  {{ billingAddressLayoutData?.title }}
                  <label for="{{ field?.name }}" class="text-[#c00100]">
                    @if (field?.required) {
                      * (Please enter the Billing address)
                    }
                  </label>
                </div>
                <button
                  class="inline-block whitespace-nowrap rounded-3xl bg-[#ffffff] hover:bg-[#F94D00] text-[13px] hover:text-[#ffffff] text-[#F94D00] cursor-pointer border border-solid font-semibold"
                  style="
                    border-color: #f94d00 !important;
                    padding: 5px 15px;
                    width: auto;
                    min-width: 0;
                  "
                  (click)="
                    editBillingAddress(billingAddressLayoutData?.action?.type)
                  "
                >
                  Edit
                </button>
              </div>
              <div
                class="md:col-span-4 border border-solid p-[10px] rounded-sm bg-[#ffffff] leading-[20px]"
                style="border-color: #dbd6dd !important"
              >
                <div class="gap-[10px] text-left text-[12px]">
                  <div class="flex flex-wrap gap-[5px]">
                    <div class="grow">
                      <span class="text-[#5B5B5B]">Name:</span> <br />
                      {{
                        data?.addressBook?.first_name ??
                          billingAddressObj()?.name
                      }}
                    </div>
                    <div class="flex-shrink-0">
                      <span class="text-[#5B5B5B]">Mobile:</span> <br />
                      {{
                        data?.addressBook?.phone ?? billingAddressObj()?.phone
                      }}
                    </div>
                  </div>
                  <div class="col-span-12">
                    <span class="text-[#5B5B5B]"> Address:</span> <br />
                    {{ billingAddress ?? billingAddressObj()?.address }}
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Buy on credit -->
          <div
            *ngIf="field?.name === inputName.IB_CREDIT && isFieldEnabled(field)"
            class="md:col-span-4 grow"
          >
            <div
              class="text-[#000000] text-left font-semibold text-[14px] mb-[5px] whitespace-nowrap"
            >
              {{ field?.placeholder }}
              <i class="fa fa-info"></i>
            </div>
            <div
              class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-4 md:gap-4"
            >
              <label
                class="flex items-center cursor-pointer"
                *ngFor="let option of field.options"
              >
                <input
                  [id]="field.name + '_' + option.value"
                  [formControlName]="field.name"
                  [value]="option.value"
                  class="h-5 w-5"
                  type="radio"
                />
                <span
                  class="first-letter:uppercase ms-2 md:text-[14px] text-[13px] font-medium whitespace-nowrap"
                >
                  {{ option.label }}
                </span>
              </label>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex flex-wrap justify-end gap-[10px]">
        @if (i > 0) {
          <div *ngIf="!updateDetails" class="md:grow-0 grow">
            <button
              matStepperPrevious
              class="md:w-auto w-full font-semibold border bg-[#162F4D] text-[#ffffff] text-[14px] disabled:bg-[#dbdada] disabled:text-[#000] disabled:cursor-not-allowed !text-center rounded-lg"
              style="border-color: #162f4d !important; padding: 13px 45px"
            >
              Back
            </button>
          </div>

          <div class="md:grow-0 grow">
            <!-- Conditionally rendering a button based on whether showVerificationAction() returns an empty value or not -->
            @if (StringUtils.isEmpty(showVerificationAction())) {
              <!-- If showVerificationAction() is empty, render the button using the stepper's button configuration -->
              <button
                mat-button
                [matTooltip]="
                  disableSubmitButton() &&
                  handleInfoMessages?.[0]?.[
                    selectedBusinessIdentificationValue()
                  ] &&
                  updateDetails
                    ? 'Please select valid Business Identification'
                    : ''
                "
                matTooltipPosition="above"
                [disabled]="disableSubmitButton()"
                (click)="
                  stepper?.button?.action?.triggerExtraStandardEvents
                    ? handleEvent(
                        business_registration_stepper,
                        null,
                        stepper?.button?.action?.triggerExtraStandardEvents,
                        null
                      )
                    : onActionCall(stepper?.button?.action?.type, i)
                "
                class="whitespace-nowrap font-semibold border bg-[#F43F0C] text-[#ffffff] text-[14px] disabled:bg-[#dbdada] disabled:text-[#000] disabled:cursor-not-allowed rounded-lg md:w-auto w-full !text-center !py-[13px] md:px-[45px] !px-[30px]"
                style="border-color: #f43f0c !important"
              >
                {{ stepper?.button?.text }}
              </button>
            } @else {
              <!-- If showVerificationAction() is not empty, render the button with the showVerificationAction() configuration -->
              <button
                mat-button
                [disabled]="disableSubmitButton() || showLoader()"
                (click)="
                  !showLoader()
                    ? handleEvent(
                        business_registration_stepper,
                        null,
                        showVerificationAction()?.action
                          ?.triggerExtraStandardEvents,
                        null
                      )
                    : null
                "
                class="font-semibold border bg-[#F43F0C] text-[#ffffff] text-[14px] disabled:bg-[#dbdada] disabled:text-[#000] disabled:cursor-not-allowed rounded-lg md:w-auto w-full !text-center !py-[13px] md:px-[45px] !px-[30px]"
                style="border-color: #f43f0c !important"
              >
                @if (showLoader()) {
                  fetching...
                } @else {
                  {{ showVerificationAction().text }}
                }
              </button>
            }
          </div>
        } @else {
          <!-- If there is no verification action at all, fallback to rendering the stepper button -->
          <button
            mat-button
            [disabled]="formDisabled()"
            (click)="
              stepper?.button?.action?.triggerExtraStandardEvents
                ? handleEvent(
                    business_registration_stepper,
                    null,
                    stepper?.button?.action?.triggerExtraStandardEvents,
                    null
                  )
                : onActionCall(stepper?.button?.action?.type, i)
            "
            class="font-semibold border bg-[#F43F0C] text-[#ffffff] text-[14px] disabled:bg-[#dbdada] disabled:text-[#000] disabled:cursor-not-allowed rounded-lg w-auto flex items-center !py-[13px] md:px-[45px] !px-[30px]"
            style="border-color: #f43f0c !important"
          >
            {{ stepper?.button?.text }}
          </button>
        }
      </div>
    </form>
  </mat-step>
</mat-stepper>
